import { useHttp } from '@/services/http'
const { get, post } = useHttp()

// 登录
export const login = data => post('/admin/auth/login', data)
// 获取验证码
export const getCaptcha = params => get('/admin/captcha', params)
// 获取用户信息
export const getUserInfo = data => post('/admin/user/info', data)

// 权限管理
// 获取管理员列表
export const getAuthList = params => get('/admin/user/getlist', params)
// 管理员添加
export const addAuth = data => post('/admin/user/save', data)
// 管理员删除
export const deleteAuth = data => post('/admin/user/del', data)
// 获取角色列表
export const getRoleList = params => get('/admin/role/getlist', params)
// 添加角色
export const addRole = data => post('/admin/role/add', data)
// 删除角色
export const deleteRole = data => post('/admin/role/del', data)

// 修改密码
export const updateUserPassword = data => post('/admin/user/pwd', data)
export const updatePassword = data => post('/admin/user/save-pwd', data)
// 菜单管理
// 获取菜单列表
export const getMenuList = params => get('/admin/menu/getlist', params)
// 添加/编辑菜单
export const saveMenu = data => post('/admin/menu/save', data)
// 删除菜单
export const deleteMenu = data => post('/admin/menu/del', data)

// 赛区管理
// 获取赛区列表
export const getDivisionList = params => get('/admin/division/getlist', params)
// 添加/编辑赛区
export const saveDivision = data => post('/admin/division/save', data)
// 删除赛区
export const deleteDivision = data => post('/admin/division/del', data)

// 初赛赛程
export const getScheduleList = params => get('/admin/schedule/getlist', params)
export const getDivisionSchedule = data => post('/admin/schedule/getSchedule', data)
export const getScheduleInfo = data => post('/admin/schedule/infoSchedule', data)
export const saveSchedule = data => post('/admin/schedule/save', data)
export const deleteSchedule = data => post('/admin/schedule/del', data)
export const theFirstStep = data => post('/admin/schedule/theFirstStep', data)
export const theStepTwo = data => post('/admin/schedule/theStepTwo', data)
export const refereeShow = data => post('/admin/schedule/referee-show', data)
// 赛程/证书等文件由后端实时生成，批量时较慢，这几个下载接口不限制超时（0=不超时，覆盖 http 默认 15s）
const DOWNLOAD_TIMEOUT = 0
export const downloadSchedule = data => post('/admin/schedule/download', data, { responseType: 'blob', timeout: DOWNLOAD_TIMEOUT })
export const sendScheduleSms = data => post('/admin/schedule/send-sms', data)
export const sendResultSms = data => post('/admin/schedule/send-result-sms', data, { timeout: 0 })
export const uploadScore = ({ s_id, excel_file }) => {
  const form = new FormData()
  form.append('s_id', s_id ?? '')
  form.append('excel_file', excel_file)
  return post('/admin/schedule/upload-score', form, {
    headers: { 'Content-Type': 'multipart/form-data' }
  })
}
// 证书下载（单个，传 song_id）
export const downloadCertificate = data => post('/admin/schedule/certificate', data, { responseType: 'blob', timeout: DOWNLOAD_TIMEOUT })
// 批量证书进度中心（传 s_id）：返回当前赛程最新任务状态，done 时包含 url/zip_url
export const getCertificateBatchProgress = (data, config = {}) => post('/admin/schedule/certificate-progress', data, config)
// 批量证书下载【提交】（传 s_id）：无可用任务时创建任务；有进行中/已完成任务时返回当前状态
export const downloadCertificateBatch = data => post('/admin/schedule/certificate-batch', data)
// 批量证书重新生成（传 s_id）：已完成、失败、无任务时创建新任务
export const regenerateCertificateBatch = data => post('/admin/schedule/certificate-regenerate', data)
// 批量证书终止（传 s_id，可附 task_id）：释放进行中任务，终止后可重新生成
export const cancelCertificateBatch = data => post('/admin/schedule/certificate-cancel', data)
// 批量证书任务状态【查询】（传 task_id）：返回 { status, total, done, url, error }，status=done 时 url 为打包 ZIP 地址
export const getCertificateBatchStatus = data => post('/admin/schedule/certificate-status', data)

// 比赛管理
// 获取比赛列表
export const getCompetitionList = params => get('/admin/competitions/getlist', params)
// 添加/编辑比赛
export const saveCompetition = data => post('/admin/competitions/save', data)
// 比赛/项目/方式/组别 状态开关
export const updateCompetitionStatus = data => post('/admin/competitions/open', data)
// 添加表演方式
export const savePerformMethods = data => post('/admin/competitions/settings', data)
// 添加管理组别
export const saveCompetitionGroup = data => post('/admin/competitions/group', data)
 


//选择比赛
export const selectCompetition = params => get('/admin/division/competitions', params)
// 流程管理保存
export const saveDivisionProcess = data => post('/admin/division/process', data)

// 选手管理
// 添加选手
export const savePlayer = data => post('/admin/player/save', data)
// 赛区报名/赛段设置保存
export const savePlayerEnroll = data => post('/admin/player/enroll', data)
// 参赛信息报名
export const saveSongEnroll = data => post('/admin/song/save', data)
// 图片上传
export const uploadImage = data => post('/common/upload', data)

export const getSongList = params => get('/admin/song/list', params)
export const getFinalSongList = params => get('/admin/song/final-list', params)
export const getFinalDivisionOptions = params => get('/admin/song/final-divisions', params)
export const downloadFinalPlayerExcel = data => post('/admin/song/final-download', data)

// 获取对应赛区选手信息
export const getPlayerList = params => get('/admin/player/list', params)

// 获取报名信息详情（用于检查删除状态）
export const getEnrollInfo = data => post('/admin/player/getEnroll', data)

// 审核
export const updateSongStatus = data => post('/admin/song/status', data)

// 删除报名信息（支持批量：id 用英文逗号拼接）
export const deleteSong = data => post('/admin/song/del', data)

// 删除参赛学员
export const deleteSongUser = data => post('/admin/song/delUser', data)

// 保存参赛学员信息
export const saveSongUser = data => post('/admin/song/saveUser', data)

// 批量上传选手（Excel）
export const uploadPlayerExcel = file => {
  const form = new FormData()
  form.append('excel_file', file)
  return post('/admin/player/getEexcel', form, {
    headers: { 'Content-Type': 'multipart/form-data' }
  })
}

export const uploadEnrollExcel = file => {
  const form = new FormData()
  form.append('excel_file', file)
  return post('/admin/player/getEexcelUser', form, {
    headers: { 'Content-Type': 'multipart/form-data' }
  })
}

export const getEexcelUserImg = data => {
  const form = new FormData()
  const list = Array.isArray(data) ? data : (data?.user_data || data?.userData || [])
  form.append('user_data', JSON.stringify(Array.isArray(list) ? list : []))
  return post('/admin/player/getEexcelUserImg', form, {
    headers: { 'Content-Type': 'multipart/form-data' }
  })
}

export const downloadPlayerExcel = data => post('/admin/player/download', data)
